/* eslint-disable @typescript-eslint/ban-ts-comment */
import { lerp, type RNG } from '@lemonade-hq/ts-helpers';
import platform from 'platform';

export function easeIn(a: number, b: number, percent: number): number {
  return a + (b - a) * percent ** 2;
}
export function easeOut(a: number, b: number, percent: number): number {
  return a + (b - a) * (1 - (1 - percent) ** 2);
}
export function easeInOut(a: number, b: number, percent: number): number {
  return a + (b - a) * (-Math.cos(percent * Math.PI) / 2 + 0.5);
}

export function mod(n: number, m: number): number {
  return ((n % m) + m) % m;
}
export function randomInt(min: number, max: number, rng?: RNG): number {
  const rand = rng?.random() ?? Math.random();
  return Math.round(lerp(min, max, rand));
}
export function randomChoice<T>(options: T[], rng?: RNG): T {
  return options[randomInt(0, options.length - 1, rng)];
}
export function accelerate(v: number, accel: number, dt: number): number {
  return v + accel * dt;
}
export function gradualChange(start: number, increment: number, max: number): number {
  // with looping
  let result = start + increment;
  while (result >= max) result -= max;
  while (result < 0) result += max;
  return result;
}

export function overlap(x1: number, w1: number, x2: number, w2: number, percent = 1): boolean {
  const half = percent / 2;
  const min1 = x1 - w1 * half;
  const max1 = x1 + w1 * half;
  const min2 = x2 - w2 * half;
  const max2 = x2 + w2 * half;

  return max1 > min2 && min1 < max2;
}

export function percentRemaining(n: number, total: number): number {
  return (n % total) / total;
}

export const isSafari = /^((?!chrome|android).)*safari/i.test(platform.ua ?? '');

if (isSafari) {
  // @ts-ignore
  // eslint-disable-next-line func-names
  HTMLCanvasElement.prototype.getContext = (orig => {
    // eslint-disable-next-line func-names
    return function (type: string, ...args: unknown[]) {
      // @ts-ignore
      return type !== 'webgl2' ? orig.apply(this, [type, ...args]) : null;
    };
  })(HTMLCanvasElement.prototype.getContext);
}

export const isIOS = platform.os?.family?.toLocaleLowerCase() === 'ios';

export const isIpad = (): boolean => {
  return !!(/(Macintosh|iPad)/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1);
};
export const isIOS15 = (): boolean => {
  return (
    (isIpad() && platform.version?.split('.')[0] === '15') || (isIOS && platform.os?.version?.split('.')[0] === '15')
  );
};
